export default {
  form: {
    should_save_payment_info: {
      label: 'Guardar datos de pago para pagar más rápido',
    },
  },
};
